export default Object.freeze({
  AusenciaJustificada: 4,
  ProveedorEnfermedad: 8,
  SituacionProveedor: 12,
  SituacionesAtribuiblesAgencia: 13,
  AusenciaAtribuiblesProveedorServicios: 14,
  AusenciaEstudianteJustificada: 15,
  AusenciaEstudianteNoJustificada: 16,
  AusenciaEspecialista: 17,
  DiaNoLectivoConcedidoPorElEstado: 18,
});
